import { ISLEntryPostBody } from "../../schemas/SLEntryPostBody";
import { SubledgerEndpoints } from "../../SubledgerEndpoints";
import { config } from "../../config";
import { authPost, authGet, authRequest, IRequestConfig } from "../../services/RequestHelpers";
import { IUserProviderState } from "../../contexts/UserContext";

export interface ISlEntryAttachment {
  readonly blobName: string;
  readonly fileName: string;
  readonly url: string;
  readonly fileSize: number;
  readonly uploadedOn: string;
  readonly isVolatile: boolean;
  readonly isSavedAlready: boolean;
}

export interface ICurrencyCode {
  readonly code: string;
}

export async function postSLEntry(
  data: ISLEntryPostBody,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ReturnType<typeof authPost>> {
  const url = config.get("subledgerUrl") + SubledgerEndpoints.slEntryPath;
  const result = await authPost(url, getTokenFn, data);
  return result;
}

export async function getSLEntry(
  slEntryId: number,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ReturnType<typeof authGet>> {
  const getSLEntryUrl = config.get("subledgerUrl") + SubledgerEndpoints.slEntryPath + slEntryId;
  const result = await authGet(getSLEntryUrl, getTokenFn);
  return result;
}

export async function getSLEntryReviewers(
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ReturnType<typeof authGet>> {
  const getReviewersUrl = config.get("subledgerUrl") + SubledgerEndpoints.slReviewers;
  const result = await authGet(getReviewersUrl, getTokenFn);
  return result;
}

const shouldntThisPatchDoSomePatching = (
  url: string,
  getTokenFn: IUserProviderState["accessToken"],
  requestCfg?: IRequestConfig
) => authRequest(url, "patch", getTokenFn, requestCfg);

export async function sendToPosterRequest(
  slEntryId: number,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ReturnType<typeof shouldntThisPatchDoSomePatching>> {
  const sendToPosterPath = SubledgerEndpoints.slEntrySendToPoster.replace("{slEntryId}", slEntryId.toString());
  const sendToPosterSLEntryUrl = config.get("subledgerUrl") + sendToPosterPath;
  const result = await shouldntThisPatchDoSomePatching(sendToPosterSLEntryUrl, getTokenFn);
  return result;
}

export async function validateEntryToSap(
  slEntryId: number,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ReturnType<typeof shouldntThisPatchDoSomePatching>> {
  const validateEntryToSapPath = SubledgerEndpoints.slEntryValidateToSap.replace("{slEntryId}", slEntryId.toString());
  const validateEntryToSapUrl = config.get("subledgerUrl") + validateEntryToSapPath;
  const result = await shouldntThisPatchDoSomePatching(validateEntryToSapUrl, getTokenFn, {
    timeout: 0
  });
  return result;
}

export async function submittedEntryForReview(
  slEntryId: number,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ReturnType<typeof shouldntThisPatchDoSomePatching>> {
  const postEntryToSapPath = SubledgerEndpoints.slEntrySubmitForReview.replace("{slEntryId}", slEntryId.toString());
  const postEntryToSapUrl = config.get("subledgerUrl") + postEntryToSapPath;
  const result = await shouldntThisPatchDoSomePatching(postEntryToSapUrl, getTokenFn);
  return result;
}
